import { IHttpApi } from '@cian/http-api/shared';

import { ICreateQuestionRequest } from '../../repositories/newbuilding-reviews/entities/create_question/CreateQuestionRequest';
import {
  fetchCreateQuestion,
  TCreateQuestionResponse,
} from '../../repositories/newbuilding-reviews/v1/create-question';
import { ResponseError } from '../../errors';

export interface IFetchQuestionParams {
  httpApi: IHttpApi;
  parameters: ICreateQuestionRequest;
}

export async function addQuestion({ httpApi, parameters }: IFetchQuestionParams): Promise<void> {
  const result: TCreateQuestionResponse = await fetchCreateQuestion({
    httpApi,
    parameters,
  });

  if (result.statusCode !== 200) {
    throw new ResponseError({
      domain: 'reviews#addQuestion',
      message: `newbuildingId: ${parameters.newbuildingId}`,
    });
  }
}
